import { render, staticRenderFns } from "./HistoryListItems.vue?vue&type=template&id=3f8423a6"
import script from "./HistoryListItems.vue?vue&type=script&lang=js"
export * from "./HistoryListItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports